// types
import { type ModuleType as ExpensiveBA } from "./_definitions"
import { type State } from "../../types"

export const expensivebaSelector = (state: State): ExpensiveBA => state.expensiveBA
